<div class="issue-report-form">
    <!-- Header Fields -->
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="equipmentId">Equipment ID</label>
                <wj-combo-box
                    [(ngModel)]="issueReport().equipmentId"
                    name="equipmentId"
                    id="equipmentId"
                    [itemsSource]="equipmentOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="dateTimeOfIssue">Date/Time of Issue</label>
                <wj-input-date-time
                    [(ngModel)]="issueReport().dateTimeOfIssue"
                    name="dateTimeOfIssue"
                    id="dateTimeOfIssue"
                    [isRequired]="false"
                ></wj-input-date-time>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="operatorName">Operator Name</label>
                <wj-combo-box
                    [(ngModel)]="issueReport().operatorName"
                    name="operatorName"
                    id="operatorName"
                    [itemsSource]="employeeOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="job">Job</label>
                <wj-combo-box
                    [(ngModel)]="issueReport().job"
                    name="job"
                    id="job"
                    [itemsSource]="jobOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="hoursMileage">Hours/Mileage</label>
                <input type="text" class="form-control" [(ngModel)]="issueReport().hoursMileage" name="hoursMileage" id="hoursMileage" />
            </div>
        </div>
    </div>

    <!-- Dropdowns Row 1: System Affected + Failure Type -->
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="systemAffected">System Affected</label>
                <wj-combo-box
                    [(ngModel)]="issueReport().systemAffected"
                    name="systemAffected"
                    id="systemAffected"
                    [itemsSource]="skillCategoryOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="true"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label>Failure Type</label>
                <wj-multi-select
                    name="failureTypes"
                    [itemsSource]="failureTypeOptions"
                    [displayMemberPath]="'display'"
                    [checkedMemberPath]="'$checked'"
                    [placeholder]="'Select failure types...'"
                    [showSelectAllCheckbox]="false"
                    [showFilterInput]="true"
                    [headerFormatter]="multiSelectHeaderFormatter"
                    (checkedItemsChanged)="onFailureTypesChanged()"
                ></wj-multi-select>
            </div>
            @if (issueReport().failureTypes.includes('Other')) {
                <div class="form-group">
                    <label for="failureTypeOther">Please specify</label>
                    <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="issueReport().failureTypeOther"
                        name="failureTypeOther"
                        id="failureTypeOther"
                    />
                </div>
            }
        </div>
    </div>

    <!-- Dropdowns Row 2: Condition Now + Safety Status -->
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="conditionNow">Condition Now</label>
                <wj-combo-box
                    [(ngModel)]="issueReport().conditionNow"
                    name="conditionNow"
                    id="conditionNow"
                    [itemsSource]="conditionNowOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="safetyStatus">Safety Status</label>
                <wj-combo-box
                    [(ngModel)]="issueReport().safetyStatus"
                    name="safetyStatus"
                    id="safetyStatus"
                    [itemsSource]="safetyStatusOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>

    <!-- Dropdowns Row 3: Quick Observations + Action Taken -->
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label>Quick Observations</label>
                <wj-multi-select
                    name="quickObservations"
                    [itemsSource]="quickObservationOptions"
                    [displayMemberPath]="'display'"
                    [checkedMemberPath]="'$checked'"
                    [placeholder]="'Select observations...'"
                    [showSelectAllCheckbox]="false"
                    [showFilterInput]="false"
                    [headerFormatter]="multiSelectHeaderFormatter"
                    (checkedItemsChanged)="onQuickObservationsChanged()"
                ></wj-multi-select>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label>Action Taken</label>
                <wj-multi-select
                    name="actionsTaken"
                    [itemsSource]="actionTakenOptions"
                    [displayMemberPath]="'display'"
                    [checkedMemberPath]="'$checked'"
                    [placeholder]="'Select actions taken...'"
                    [showSelectAllCheckbox]="false"
                    [showFilterInput]="false"
                    [headerFormatter]="multiSelectHeaderFormatter"
                    (checkedItemsChanged)="onActionsTakenChanged()"
                ></wj-multi-select>
            </div>
        </div>
    </div>

    <!-- Dropdowns Row 4: Severity + Suggested Mechanic -->
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="severity">Severity</label>
                <wj-combo-box
                    [(ngModel)]="issueReport().severity"
                    name="severity"
                    id="severity"
                    [itemsSource]="severityOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="suggestedMechanic">Suggested Mechanic (optional)</label>
                <wj-combo-box
                    [(ngModel)]="issueReport().suggestedMechanicHrRef"
                    name="suggestedMechanic"
                    id="suggestedMechanic"
                    [itemsSource]="mechanicOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>

    <!-- Short Description -->
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="shortDescription">Short Description</label>
                <textarea
                    rows="3"
                    class="form-control"
                    [(ngModel)]="issueReport().shortDescription"
                    name="shortDescription"
                    id="shortDescription"
                    placeholder="Describe the issue..."
                ></textarea>
            </div>
        </div>
    </div>

    <!-- Attachments -->
    <div class="form-group">
        <label>Attachments</label>
        <div class="row">
            <div class="col-4">
                <button type="button" class="btn btn-secondary btn-attachment" (click)="fileInput.click()">
                    <fa-icon [icon]="faCamera"></fa-icon> Photos
                </button>
                <input #fileInput style="display: none" type="file" (change)="onFileChanged($event)" accept="image/*" multiple />
            </div>
            <div class="col-4">
                <button type="button" class="btn btn-secondary btn-attachment" (click)="videoInput.click()">
                    <fa-icon [icon]="faVideo"></fa-icon> Videos
                </button>
                <input #videoInput style="display: none" type="file" (change)="onVideoChanged($event)" accept=".mp4" multiple />
            </div>
            <div class="col-4">
                <button type="button" class="btn btn-secondary btn-attachment" (click)="docInput.click()">
                    <fa-icon [icon]="faFile"></fa-icon> <span class="d-none d-sm-inline">Documents</span
                    ><span class="d-inline d-sm-none">Docs</span>
                </button>
                <input
                    #docInput
                    style="display: none"
                    type="file"
                    (change)="onDocumentChanged($event)"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                    multiple
                />
            </div>
        </div>
    </div>

    @if (issueReport().existingImageUrls.length > 0) {
        <div class="row">
            <div class="col-12">
                <h6 class="mt-2">Saved Attachments</h6>
            </div>
            @for (url of issueReport().existingImageUrls; track url) {
                <div class="col-sm-4 col-6" style="margin-bottom: 10px">
                    <div class="attachment-preview" style="cursor: pointer" (click)="openImage(url)">
                        @if (isVideo(url)) {
                            <video [src]="getExistingFileSrc(url)" muted preload="metadata"></video>
                        } @else if (isPdf(url)) {
                            <img class="attachment-pdf-thumb" src="./Resources/pdfImage.png" alt="" />
                        } @else {
                            <img [src]="getExistingFileSrc(url)" />
                        }
                    </div>
                </div>
            }
        </div>
    }

    @if (issueReport().images.length > 0) {
        <div class="row">
            <div class="col-12">
                <h6 class="mt-2">Photos to Upload</h6>
            </div>
            @for (image of issueReport().images; track image) {
                <div class="col-sm-4 col-6" style="margin-bottom: 10px">
                    <div class="attachment-preview">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img [src]="image.url" />
                    </div>
                </div>
            }
        </div>
    }

    @if (issueReport().videos.length > 0) {
        <div class="row">
            <div class="col-12">
                <h6 class="mt-2">Videos to Upload</h6>
            </div>
            @for (video of issueReport().videos; track video) {
                <div class="col-sm-4 col-6" style="margin-bottom: 10px">
                    <div class="attachment-preview">
                        <div class="close-x" (click)="removeVideo(video)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <video controls [src]="video.previewSrc"></video>
                    </div>
                </div>
            }
        </div>
    }

    @if (issueReport().documents.length > 0) {
        <div class="row">
            <div class="col-12">
                <h6 class="mt-2">Documents to Upload</h6>
            </div>
            @for (doc of issueReport().documents; track doc) {
                <div class="col-12" style="margin-bottom: 6px">
                    <div class="document-item">
                        <fa-icon [icon]="faFile"></fa-icon>
                        <span class="document-name">{{ doc.name }}</span>
                        <span class="close-x-inline" (click)="removeDocument(doc)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </span>
                    </div>
                </div>
            }
        </div>
    }

    @if (progress > 0 && progress < 100) {
        <div class="row mt-2">
            <div class="col-12">
                <div class="progress">
                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width.%': progress }" aria-valuemin="0" aria-valuemax="100">
                        {{ progress }}%
                    </div>
                </div>
            </div>
        </div>
    }
</div>
